import styled from "styled-components";
import { deviceSizesMin } from "../../../../DeviceSizes";

export const ArticleContainer = styled.div`
  padding: 0px 30px 50px 30px;
  margin-left: auto;
  margin-right: auto;

  @media only screen and ${deviceSizesMin.laptop} {
    width: 1170px;
  }

  @media only screen and ${deviceSizesMin.tablet} {
  }
`;

export const ArticleImage = styled.img`
  width: 50%;
  height: inherit;
  margin: auto;
`;

export const ArticleEditButton = styled.a`
  border: 2px solid black;
  color: black;

  display: flex;
  justify-content: center;
  height: 45px;
  width: 180px;
  font-size: 14px;
  font-weight: bolder;
  letter-spacing: 1.14px;
  line-height: 20px;
  text-transform: uppercase;

  align-items: center;
  transition: all 0.2s;
  cursor: pointer;

  text-decoration: none;
  background: transparent;

  &:hover {
    color: white;
    background: black;
    box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.05);
  }
`;

export const ArticleWrapper = styled.article`
  display: block;

  @media only screen and ${deviceSizesMin.laptop} {
    width: 80%;
    margin: 0 auto 1.5em auto;
  }
`;

export const ArticleHeader = styled.header`
  display: block;
  margin-top: 100px;
`;

export const ArticleTitle = styled.h2`
  margin-bottom: 5px;
  font-size: 30px;
  font-weight: bolder;
  margin-top: 20px;
  line-height: 1.1;
  clear: both;
  letter-spacing: 1.5px;
  text-align: left;
  text-transform: uppercase;
`;

export const ArticleMeta = styled.p`
  font-size: 12px;
  color: #1c1c1c;
  margin-bottom: 25px;
`;

export const ArticleContentFrame = styled.div`
  position: relative;
  display: block;
  width: 100%;
`;
